export const environment = {
  production: true,
  imageUrl: 'https://cdn.illpeoplemusic.com/imges/imgs/',
  apiBaseUrl: 'https://api-server.illpeoplemusic.com/api/v2/',
  beatPlayUrl: 'https://d2o3vwndhrrwn8.cloudfront.net/play?beatid=',
  amazonPlayUrl: 'https://cdn.illpeoplemusic.com/play?beatid=',
  soundPlayUrl: 'https://d2o3vwndhrrwn8.cloudfront.net/play-sound?soundid=',
  amazonGetTicketUrlSound: 'https://qd3swvz3j9.execute-api.ap-south-1.amazonaws.com/prod/get-ticket',
  waveformApiUrl: 'https://2cbq8dyl48.execute-api.ap-south-1.amazonaws.com/prod/waveform',
  amazonGetTicketUrl: 'https://x0by96g2pj.execute-api.ap-south-1.amazonaws.com/test/getticket?music=',
  shareUrl: 'https://beat22.com/',
  rozarPayDevKey: 'rzp_live_cV1JlOuST6K1bg',
  subscriptionType: "prod",
  calverTapId: "679-6R5-847Z",
  hareBeat22Url: 'https://beat22.com/',
  shareBeat22Url: 'https://beat22.com/',
  firebaseConfig :  {
    apiKey: "AIzaSyDZkqZOYLf9pcj6TjNvAfKovD95Uz_llqc",
    authDomain: "illpeople-music.firebaseapp.com",
    projectId: "illpeople-music",
    storageBucket: "illpeople-music.appspot.com",
    messagingSenderId: "58360648302",
    appId: "1:58360648302:web:d66a78fd0f55c951374c7f",
    measurementId: "G-N6J1B7X0D9"
  },
  clientIdGoogle: '502950159647-31pmqonoss63fpk2fjcr79sb15qbersq.apps.googleusercontent.com'
};
